import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

// @TODO
// Make this component having same markup

const Title = ({ regional, lensName }) => {
  return (
    <Fragment>
      <div className="message--wrapper">
        {regional && (
          <Fragment>
            <FormattedMessage
              id="looks.you_have_chosen"
              defaultMessage="You have chosen:"
            />
            <span
              className="text-golden"
              dangerouslySetInnerHTML={{
                __html: lensName
              }}
            />
          </Fragment>
        )}
        {!regional && (
          <Fragment>
            <FormattedMessage
              id="looks.you_have_chosen"
              defaultMessage="You have chosen:"
            />
            <span className="name">{lensName}</span>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default Title;
